// extracted by css-extract-rspack-plugin
export default {"header":"Ch4SX","box":"zrYMd"};